
import React      from 'react';
import CSSModules from 'react-css-modules';
import Dropzone   from 'react-dropzone';

import Button        from '../Button';
import Input         from '../Input';
import InputGroup    from '../InputGroup';
import Label         from '../Label';
import FontIcon      from '../FontIcon';
import InlineError   from '../InlineError';
import ProgressBar   from '../ProgressBar';

import * as resourceActions from '../../actions/resourcePackList';

import resourcesApi      from '../../services/resourcePacks';
import responseFormatter from '../../services/responseFormatter';

import { reduxForm } from 'redux-form';

import style from './style.scss';

class ResourcePackForm extends React.Component {

    constructor() {

        super();

        this.state = {
            uploadProgress: 0
        };
    }

    _addFilesToList(files) {

        const existingFiles = this.props.fields.files.value;

        const newFileList = existingFiles.concat(this._formatSelectedFiles(files));

        this.props.fields.files.onChange(newFileList);
    }

    _formatSelectedFiles(files) {

        return files.map((file) => {

            file.mime_type     = file.type;
            file.selected_file = true;

            return file;
        });
    }

    _uploadProgressUpdated(progressPercent) {

        this.setState({
            uploadProgress: progressPercent
        });
    }

    _setIsUploadingState(isUploading) {

        this.setState({
            isUploading
        });
    }

    _submitResourcePack(formData) {

        return new Promise((resolve, reject) => {

            function success() {

                this._setIsUploadingState(false);

                this.props.submitted();

                resolve();
            }

            function failed(response) {

                this._setIsUploadingState(false);

                reject(responseFormatter.apiErrorsToFormErrors(response.data.errors));
            }

            this._setIsUploadingState(true);

            if (this.props.mode === 'add') {

                resourcesApi.create(formData, this._uploadProgressUpdated.bind(this))
                    .then(success.bind(this), failed.bind(this));

            } else if (this.props.mode === 'edit') {

                resourcesApi.update(formData, this._uploadProgressUpdated.bind(this))
                    .then(success.bind(this), failed.bind(this));
            }
        });
    }

    _removeFileToAdd(fileIndex) {

        const files = this.props.fields.files.value.filter((file, index) => {

            return fileIndex !== index;
        });

        this.props.fields.files.onChange(files);
    }

    _getFileList(files) {

        if (files.value) {

            return files.value.map((file, index) => {

                return (
                    <div key={ index }>

                        <FontIcon className={ style['file-icon'] } mimeType={ file.mime_type } />

                        <span>{ file.name }</span>

                        <span onClick={ this._removeFileToAdd.bind(this, index) }
                              styleName="remove-file-button">&times;</span>
                    </div>
                );
            });
        }
    }

    _getProgressBar() {

        if (this.state.isUploading) {

            return (
                <ProgressBar styleName="progress-bar" progress={ this.state.uploadProgress } />
            );
        }
    }

    render() {

        const { fields: { name, files }, submitting, handleSubmit } = this.props;

        return (
            <form onSubmit={ handleSubmit(this._submitResourcePack.bind(this)) }>

                <InputGroup>
                    <Label isRequired="true">Pack Name</Label>
                    <Input { ...name } errors={ name.error }/>
                    <InlineError errors={ name.error } />
                </InputGroup>

                <div styleName="file-list">

                    { this._getFileList(files) }

                </div>

                <Dropzone ref={ (elem) => this.dropzone = elem }
                          onDrop={ this._addFilesToList.bind(this) }
                          activeClassName={ style['drag-n-drop--dragging'] }
                          className={ style['drag-n-drop'] }
                          multiple={ true }>

                    <span styleName="drag-n-drop__instruction">Drag and drop files</span>

                    <span styleName="drag-n-drop__or">or</span>

                    <Button autoWidth="true" type="button">
                        <span>Browse for files</span>
                    </Button>

                </Dropzone>

                { this._getProgressBar() }

                <Button styleName="save-button"
                        disabled={ submitting }
                        type="submit"
                        theme="success">
                    <span>Save</span>
                </Button>

            </form>
        );
    }
}

function mapStateToProps(state) {

    const pageState = state.resourcePackList;

    var initialValues = {
        id: 0,
        name: '',
        files: []
    };

    if (pageState.isEditResourcePackOverlayOpen) {

        const packToEdit = pageState.packToEdit;

        initialValues = {
            id: packToEdit.id,
            name: packToEdit.name,
            files: packToEdit.files
        }
    }

    return {
        ...state.resourcePackList,
        initialValues
    };
}

function mapDispatchToProps(dispatch) {

    return {
        refreshResourcePacks() {

            dispatch(resourceActions.refreshResourcePacks());
        },
        removeFileToAdd(fileIndex) {

            dispatch(resourceActions.removeFileToAdd(fileIndex));
        },
        addFilesToList(files) {

            dispatch(resourceActions.addFilesToList(files));
        }
    };
}

const formConfig = {
    form: 'resource-pack',
    fields: [
        'id',
        'name',
        'files'
    ]
};

export default reduxForm(formConfig, mapStateToProps, mapDispatchToProps)(CSSModules(ResourcePackForm, style));


// WEBPACK FOOTER //
// ./components/ResourcePackForm/index.js